import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import {TrackJS} from 'trackjs';
import * as Sentry from "@sentry/react";
import {getDefaultIntegrations} from "@sentry/react";

TrackJS.install({
    token: "e3cf028973ca480897c05a76e5470538",
    application: "client"
});

const defaultIntegrations = getDefaultIntegrations({}).filter(() => {
    // Example: Exclude CaptureConsole if you add it manually or don't need it
    // return integration.name !== 'CaptureConsole';
    return true;
});

Sentry.init({
    dsn: "https://49d25eecbf1408f49327fde677cddfbf@o4508335801303040.ingest.de.sentry.io/4508335805104208",
    integrations: [
        ...defaultIntegrations,
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: true,
        }),
        Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],
    environment: import.meta.env.VITE_ENVIRONMENT,

    // Performance Monitoring
    tracesSampleRate: 0.1,
    tracePropagationTargets: ["localhost", /^https?:\/\/.*\.xano\.io\/api/],
    profilesSampleRate: 1.0,

    // Session Replay
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,

    debug: import.meta.env.VITE_ENVIRONMENT === 'local',
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
)
